// extracted by mini-css-extract-plugin
module.exports = {"message":"y6sLa","header":"XpC17","icon":"FwSQc","title":"_3bplc"};